import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from '@emotion/styled';
import _ from 'lodash';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import {Snackbar, SnackbarContent} from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import DataTable from './DataTable';

import {deleteAdminCustomer, deleteAdminVariant, deleteAdminReview, getAdminCustomerOrders, getAllAdminReviews, getAdminReview, updateAdminCustomer, updateAdminReview} from '../../network';
import {formatDate, padding} from '../../utils/formatter';
import {capitalize} from '../../helpers/Helper';
import ReviewOverlayComponent from '../shared/ReviewOverlayComponent';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 14.75rem);
  height: 100vh;
  //height: 100%;
  
  padding: 1rem 1.5rem 0 1.5rem;
`;

const PageHeader = styled.h1`
  height: 1.25rem;
  font-size: 1.25rem;
  line-height: 1.25rem;
  
  font-family: OpticianSans, serif;
  font-style: normal;
  font-weight: normal;
  
  color: var(--color-gray-500);
`;

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: -webkit-fill-available;
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;
`;

const Tag = styled.div`
  display: flex;
  width: fit-content;
  padding: var(--space-4) var(--space-6);

  font-size: var(--font-12);
  font-weight: 500;
  color: ${props => props.color ? `var(--color-${props.color}-800)` : ''};
  background-color: ${props => props.color ? `var(--color-${props.color}-100)` : ''};
  box-shadow: ${props => props.color ? `0 0 0 1px var(--color-${props.color}-300)` : '0 0 0 1px #C8E1D2'};
  border-radius: var(--space-4);
`;

const Label = styled.span`
  color: var(--color-gray-600);
  width: 6rem;
`;

const OrderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: var(--space-24);
  margin-right: var(--space-24);
  margin-bottom: var(--space-16);
  & > span:first-of-type {
    font-weight: 500;
    color: var(--company-dark);
  }
  & > span:last-of-type {
    color: var(--color-gray-700);
  }
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-bottom: 1rem;
  > a {
    color: var(--company-dark);
    font-weight: 500;
    width: 12.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:last-of-type {
      margin-bottom: var(--space-28); 
    }
`;

const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  justify-content: space-between;
  padding-top: var(--space-16);
  padding-left: var(--space-20);
  padding-right: var(--space-20);
  padding-bottom: var(--space-8);
  border-top: 1px solid var(--color-gray-300);
  > button {
    border: none;
    box-shadow: none;
    background: none;
    padding: var(--space-6) var(--space-8);
    border-radius: var(--space-4);
    color: var(--company-dark);
    font-size: var(--font-16);
    font-weight: normal;
    &:hover {
      background-color: var(--color-gray-200);
      transition: background-color 0.3s ease-in;
    }
    &:last-of-type {
      color: var(--color-red-700);
    }
    &:disabled {
      color: var(--color-gray-500);
      cursor: not-allowed;
    }
  }
`;

const InnerDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: calc(100% - var(--space-32));
  line-height: 1.2;
  vertical-align: center;
  font-size: var(--font-14);
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;

  background: white;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;

  padding: 0 1.5rem 0 1.5rem;

  justify-content: space-between;
  align-items: center;
`;

const FilterSection = styled.div`
  display: flex;
  align-items: center;

  > span {
    height: 0.875rem;

    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
    color: var(--color-gray-600);
  }
`;

const Dropdown = styled.div`
  border: 1px solid var(--color-gray-300);
  box-sizing: border-box;
  border-radius: 1.5rem;
  
  margin: 0 0 0 1rem;
  padding: 0 0.75rem 0 0.75rem;
  
  > select {
    height: 1.5rem;
    
    background: transparent;
    
    border: 0;
  
    appearance: none;
    outline: none;

    
    font-size: 0.75rem;
    font-weight: 500;
    
    color: var(--color-gray-800);
  }
  
  > img {
    margin-left: var(--space-8);
  }
`;

const SearchSection = styled.div`
  display: flex;
  align-items: center;
  width: 30%;
  
  > img {
    position: relative;
    left: 90%;
  }
  
  > input {
    width: 100%;
    height: 1.875rem;
    
    padding: 1rem;
    background: white;
    
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 4px;
    
    color: var(--color-gray-500);
    
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
`;

const CellText = styled.span`
  width: 90%;
  
  
  font-style: normal;
  //font-weight: 500;
  font-size: 0.875rem;
  line-height: 1rem;

  color: var(--color-gray-900);
  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Divider = styled.div`
  width: calc(100% - var(--space-48));
  margin-top: var(--space-8);
  margin-bottom: var(--space-24);
  margin-left: var(--space-24);
  height: 1px;
  background-color: var(--color-gray-300);
`;

const MasterContainer = styled.div`
  //height: -webkit-fill-available;
  height: calc(100vh - 2.5rem); // desperation
  flex-grow: 1;
  margin-right: 1.5rem;
`;

const DetailContainer = styled.div`
  width: 24rem;
  height: calc(100vh - 4.5rem); // desperation
`;
const DetailHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-top: 1rem;
  margin-bottom: 2rem;
  > span {

    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.375rem;

    color: var(--color-gray-900);
  }
`;
const useStyles = makeStyles({
    root: {
      width: 120,
      display: 'flex',
      alignItems: 'center',
    },
  });
function BackOfficeReviews({auth}) {
    const classes = useStyles();
    const [reviews, setreviews] = useState([]);
    const [confirm, setConfirm] = useState();
    const [cancel, setCancel] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [sort, setSort] = useState({
        sortOrder: 'desc',
        sortBy: 'updatedAt'
    });
    const [filter, setFilter] = useState();
    const [details, setDetails] = useState(null);
    const [detailsEdit, setDetailsEdit] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(25);
    const [pageCount, setPageCount] = useState(1);
    const [toast, setToast] = useState(false);
    const [toastText, setToastText] = useState('');

    const adminToken = auth ? auth.token : null;

    const filters = [
        {
            value: 'latest',
            text: 'Latest'
        },
        {
            value: 'lowest',
            text: 'Lowest Rating'
        },
        {
            value: 'highest',
            text: 'Highest Rating'
        },
        {
            value: 'Pending',
            text: 'Pending'
        },
        {
            value: 'Approved',
            text: 'Approved'
        }
    ];
    const headers = [
        {
            title: 'Review ID',
            sortable: true,
            sort: 'review_id'
        },
        {
            title: 'Review',
            sortable: true,
            sort: 'comment'
        },
        {
            title: 'Product',
            sortable: true,
            sort: 'product'
        },
        {
            title: 'Rating',
            sortable: true,
            sort: 'rating'
        },
        // {title: 'Type'},
        {
            title: 'Status',
            sortable: true,
            sort: 'status'
        }
    ];

    useEffect(() => search(searchText), [searchText,filter,sort]);
    

    const search = (searchText) => {
        getAllAdminReviews(searchText,pageLimit,currentPage,'',sort.sortOrder,sort.sortBy)
            .then(result => {
                setDetails(null);
                setDetailsEdit(null);
                setreviews([...result.data]);
                setPageCount(Math.ceil(result.total / pageLimit));
                
            })
            .catch(error => console.error(error));
    };

    // const removeCustomer = id => {
    //     deleteAdminCustomer(adminToken, id)
    //         .then(() => {
    //             setDetails(null);
    //             setDetailsEdit(null);
    //             search(searchText);
    //         })
    //         .catch(error => console.error(error));
    // };

    const changeSort = sort => setSort(sort);

    const changePage = direction => {
        if (currentPage === 1 && direction < 0) return;
        if (currentPage === pageCount && direction > 0) return;

        setreviews([]);
        setCurrentPage(currentPage + (direction));
    };

    const debouncedSearchText = _.debounce(query => {
        setSearchText(query);
    }, 400);

    const handleSearchChange = e => {
        const value = e.target.value.trim();
        debouncedSearchText(value);
    };

    const onRowSelect = data => {
        getAdminReview(data?._id)
            .then(result => {
                // let orders = [];
                // result.data.forEach(order => {
                //     orders.push({
                //         ticket: order.review_id,
                //         order_date: order.createdAt
                //     });
                // });

                // const details = {
                //     review: data,
                //     orders
                // };
                console.log(result);
                setDetails(result);
                setDetailsEdit(null);
            })
            .catch(error => console.error(error));
    };
    useEffect(() => { if (sort.sortBy !== 'updatedAt') onRowSelect(reviews[0])}, [reviews, sort]);
    const dataRows = data => {
        let rows = [];
        data.map(item => {
            rows.push({
                onRowSelect,
                data: item,
                view: <>
                    <CellText>{item.admin_review_id}</CellText>
                    <CellText>{item.comment}</CellText>
                    <CellText>{item.product.name}</CellText>
                    <CellText>
                        <Rating
                            name="hover-feedback"
                            value={item.rating.$numberDecimal.toString()}
                            precision={0.5}
                            disabled
                        />
                    </CellText>
                    {/* <CellText style={{
                        color: '#049CBE',
                        cursor: 'pointer',
                        fontWeight: 500
                    }}>{item.email}</CellText> */}
                    <CellText>{capitalize(item.status)}</CellText>
                    {/* {item.active ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>} */}
                </>
            });
        });
        return rows;
    };

    const handleEditChange = e => {
        const {value, name} = e.target;
        setDetailsEdit({
            ...detailsEdit,
            [name]: value
        });
    };

    const evalPrimaryAction = () => {
        if (details.status === 'Pending') { 
            updateAdminReview(details._id, {status: 'Approved'})
                .then(result => {search(searchText); setToastText('Approved'); setToast(true); })
                .catch(error => console.error(error));
        } else {
            updateAdminReview(details._id, {status: 'Pending'})
                .then(result => search(searchText))
                .catch(error => console.error(error));
        }
        // if (!detailsEdit) setDetailsEdit({...details.customer});
        // else {
        //     // eval if valid information entered, collect updates and update customer
        //     updateReview(detailsEdit._id, detailsEdit)
        //         .then(result => search(searchText))
        //         .catch(error => console.error(error));
        // }
    };

    const evalSecondaryAction = () => {
        setCancel(true);
    };

    const deleteReview = () => {
        deleteAdminReview(details?._id)
        .then(result => {search(searchText); setToastText('Canceled'); setToast(true); setCancel(false);})
        .catch(error => console.error(error));
    }

    // useEffect(() => {
    //     if(cancel){
    //         const saved = localStorage.getItem("id");
    //         deleteAdminReview(saved)
    //         .then(result => {search(searchText); setToastText('Canceled'); setToast(true)})
    //         .catch(error => console.error(error));
    //     }
    // }, [cancel]);

    const onFilterChange = (value) => {
        setFilter(value);
        if(value === 'highest'){
            setSort({
                sortOrder: 'desc',
                sortBy: 'rating'
            })
        }
        else if(value === 'lowest'){
            setSort({
                sortOrder: 'asc',
                sortBy: 'rating'
            })
        }
        else if(value === 'latest'){
            setSort({
                sortOrder: 'desc',
                sortBy: 'createdAt'
            })
        }
        else{
            setSearchText(value);
        }
    }


    return (

        <Container>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={toast}
                autoHideDuration={5000}
                onClose={()=>setToast(false)}
                key={'toast'}
            >
                <SnackbarContent
                    style={{backgroundColor: '#02B2D9', minWidth: 'auto', borderRadius: '8px', border: '2px solid #049CBE'}}
                    message={<span id="client-snackbar">{`✓ Review Successfully ${toastText}`}</span>}
                />
            </Snackbar>
            <MasterContainer>
                {
                    cancel &&
                        <ReviewOverlayComponent setCancel={setCancel} setConfirm={deleteReview}/>
                }
                <PageHeader>REVIEWS</PageHeader>
                <ContentContainer>
                    <Row style={{marginBottom: '1rem'}}>
                        <FilterSection>
                            <span>Filter by</span>

                            <Dropdown>
                                <select value={filter} onChange={e => onFilterChange(e.target.value)}>
                                    <option value=''>All</option>
                                    {
                                        filters.map((filter, index) => {
                                            return <option key={`BackofficeReviewsFilterOption_${index}`} value={filter.value}>{filter.text}</option>;
                                        })
                                    }
                                </select>
                                <img alt='dropdown' src='/icons/chevron.svg'/>
                            </Dropdown>
                        </FilterSection>

                        <SearchSection>
                            <img src='/icons/search.svg' alt='search icon'/>
                            <input placeholder='Search here...' type='text' onChange={handleSearchChange}/>
                        </SearchSection>
                    </Row>

                    <DataTable
                        highlight={sort.sortBy !== 'updatedAt' && reviews[0]?._id}
                        headers={headers}
                        rows={dataRows(reviews)}
                        changeSort={changeSort}
                        spacing={'20% 20% 20% 20% 20%'}
                        currentPage={currentPage}
                        pageCount={pageCount}
                        pageBack={() => changePage(-1)}
                        pageNext={() => changePage(1)}
                    />
                </ContentContainer>
            </MasterContainer>

            {
                details && <DetailContainer>
                    <PageHeader>DETAILS</PageHeader>
                    <InnerDetailContainer>
                        <DetailHeader>
                            <span>{`Review ${details.admin_review_id}`}</span>
                        </DetailHeader>
                        <DetailRow>
                            <Label>Status:</Label>
                            <span>{details.status === 'Approved' ? <Tag color="green">{details.status}</Tag>: <Tag color="red">{details.status}</Tag>}</span>
                        </DetailRow>
                        <DetailRow>
                            {console.log("Customer ",details)}
                            <Label>Customer:</Label>
                            <Link  to={{
                                pathname: "/backoffice/customers",
                                state: { customerId: details.customer?.first_name }
                            }}
                            >{`${details.customer?.first_name} ${details.customer?.last_name}`}</Link>
                        </DetailRow>
                        <DetailRow>
                            <Label>Product:</Label>
                            <span style={{width:'225px'}}>{details.product.name}</span>
                        </DetailRow>
                        <DetailRow style={{alignItems:'center'}}>
                            <Label>Rating:</Label>
                            <DetailRow style={{margin:0}}>
                            <div className={classes.root}>
                                <Rating
                                    name="hover-feedback"
                                    value={details.rating.$numberDecimal}
                                    precision={0.5}
                                    disabled
                                />
                            </div>
                            <span style={{alignSelf:'center', paddingLeft:'5px'}}>{details.rating.$numberDecimal}</span>
                            </DetailRow>
        
                        </DetailRow>
                        <DetailRow>
                            <Label>Usefulness:</Label>
                            <span>{`${details.likes ? details.likes : 0} Customers found this useful`}</span>
                        </DetailRow>
                        <DetailRow>
                            <Label>Posted:</Label>
                            <span>{moment(details.createdAt).format("MMM DD, YYYY")}</span>
                        </DetailRow>
                        {/* <DetailRow>
                            <Label>Type:</Label>
                            {
                                detailsEdit ?
                                    <Dropdown style={{margin: '0'}}>
                                        <select name="type" value={detailsEdit.type} onChange={handleEditChange}>
                                            {
                                                filters.map((filter, index) => {
                                                    return <option key={`BackofficereviewsEditTypeOption_${index}`} value={filter.value}>{filter.text}</option>;
                                                })
                                            }
                                        </select>
                                        <img alt='dropdown' src='/icons/chevron.svg'/>
                                    </Dropdown>
                                    : <span>{capitalize(details.customer.type)}</span>
                            }
                        </DetailRow>
                        {
                            details.customer.contact && <DetailRow>
                                <Label>Contact:</Label>
                                <a href={`tel:+${details.customer.contact}`}>{`+${details.customer.contact}`}</a>
                            </DetailRow>
                        } */}
                        {/* <DetailRow>
                            <Label>Status:</Label>
                            {
                                detailsEdit ?
                                    <Dropdown style={{margin: '0'}}>
                                        <select name="active" value={detailsEdit.active} onChange={handleEditChange}>
                                            {
                                                [{
                                                    value: true,
                                                    text: 'Active'
                                                }, {
                                                    value: false,
                                                    text: 'Inactive'
                                                }].map((filter, index) => {
                                                    return <option key={`BackofficereviewsEditStatusOption_${index}`} value={filter.value}>{filter.text}</option>;
                                                })
                                            }
                                        </select>
                                        <img alt='dropdown' src='/icons/chevron.svg'/>
                                    </Dropdown>
                                    : details.customer.active
                                    ? <Tag color="green">Active</Tag>
                                    : <Tag color="red">Inactive</Tag>
                            }
                        </DetailRow> */}
                        {/*<DetailRow>*/}
                        {/*    <Label>Status:</Label>*/}
                        {/*    <Tag>Registered</Tag>*/}
                        {/*</DetailRow>*/}
                        <Divider/>
                        <DetailRow>
                            <Label>Review:</Label>
                        </DetailRow>
                        <DetailRow>
                            <span style={{fontStyle:'italic'}}>{details.comment}</span>
                        </DetailRow>
                        {/* {
                            details.orders.map((order, index) => {
                                return <OrderItem key={`OrderItem_${index}`}>
                                    <span>Order {padding(order.ticket, 8)}</span>
                                    <span>{formatDate(order.order_date, 'MMM DD, YYYY')}</span>
                                </OrderItem>;
                            })
                        } */}
                        
                        <ActionsBar>
                            <button onClick={evalPrimaryAction}>{details.status === 'Approved' ? 'Revert Approve' : 'Approve'}</button>
                            <button onClick={evalSecondaryAction}>{'Delete'}</button>
                        </ActionsBar>
                    </InnerDetailContainer>
                </DetailContainer>
            }
        </Container>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user
});

export default connect(mapStateToProps, null)(BackOfficeReviews);
